// src/contexts/UserRoleContext.js
import { createContext, useContext, useEffect, useState } from "react";

// Create the context
const UserRoleContext = createContext();

// Provider component
export const UserRoleProvider = ({ children }) => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    // You can customize this logic to fetch the role from localStorage, API, etc.
    const storedRole = localStorage.getItem("userRole"); // e.g., 'LABORATORY'
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  return (
    <UserRoleContext.Provider value={{ role, setRole }}>
      {children}
    </UserRoleContext.Provider>
  );
};

// Custom hook for easy access
export const useUserRole = () => useContext(UserRoleContext);